export default "/images/evoca_bank.png?f2d9cb979463bf47ed6a70308b9fe063";